import { useState } from "react";


export function useFormFields<T>(initialValues: T) {
    const [formFields, setFormFields] = useState<T>(initialValues);

    const createChangeHandler = (key: keyof T) => (
        e: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const value = e.target.value;
        setFormFields((prev: T) => ({ ...prev, [key]: value }));
    };

    const createChangeValueHandler = (key: keyof T) => (
        e: any,
        value: any
    ) => {
        setFormFields((prev: T) => ({ ...prev, [key]: value }));
    };

    const createMouseValueHandler = (key: keyof T) => (
        e: React.MouseEvent,
        value: string
    ) => {
        if (value !== null) {
            setFormFields((prev: T) => ({ ...prev, [key]: value }));
        }
    };

    return { formFields, setFormFields, createChangeHandler, createChangeValueHandler, createMouseValueHandler };
}